/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type { PartnerContactRequest } from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const throw400 = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/operations/own/exception/400`,
    method: 'GET',
    signal,
  });
};

export const getThrow400QueryKey = () => {
  return [`/operations/own/exception/400`] as const;
};

export const getThrow400QueryOptions = <
  TData = Awaited<ReturnType<typeof throw400>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof throw400>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getThrow400QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof throw400>>> = ({
    signal,
  }) => throw400(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof throw400>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type Throw400QueryResult = NonNullable<
  Awaited<ReturnType<typeof throw400>>
>;
export type Throw400QueryError = unknown;

export const useThrow400 = <
  TData = Awaited<ReturnType<typeof throw400>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof throw400>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getThrow400QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const throw404 = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/operations/own/exception/404`,
    method: 'GET',
    signal,
  });
};

export const getThrow404QueryKey = () => {
  return [`/operations/own/exception/404`] as const;
};

export const getThrow404QueryOptions = <
  TData = Awaited<ReturnType<typeof throw404>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof throw404>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getThrow404QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof throw404>>> = ({
    signal,
  }) => throw404(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof throw404>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type Throw404QueryResult = NonNullable<
  Awaited<ReturnType<typeof throw404>>
>;
export type Throw404QueryError = unknown;

export const useThrow404 = <
  TData = Awaited<ReturnType<typeof throw404>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof throw404>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getThrow404QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const throw500 = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/operations/own/exception/500`,
    method: 'GET',
    signal,
  });
};

export const getThrow500QueryKey = () => {
  return [`/operations/own/exception/500`] as const;
};

export const getThrow500QueryOptions = <
  TData = Awaited<ReturnType<typeof throw500>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof throw500>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getThrow500QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof throw500>>> = ({
    signal,
  }) => throw500(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof throw500>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type Throw500QueryResult = NonNullable<
  Awaited<ReturnType<typeof throw500>>
>;
export type Throw500QueryError = unknown;

export const useThrow500 = <
  TData = Awaited<ReturnType<typeof throw500>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof throw500>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getThrow500QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const clearing = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/operations/own/exception/clearing`,
    method: 'GET',
    signal,
  });
};

export const getClearingQueryKey = () => {
  return [`/operations/own/exception/clearing`] as const;
};

export const getClearingQueryOptions = <
  TData = Awaited<ReturnType<typeof clearing>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof clearing>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getClearingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof clearing>>> = ({
    signal,
  }) => clearing(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof clearing>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ClearingQueryResult = NonNullable<
  Awaited<ReturnType<typeof clearing>>
>;
export type ClearingQueryError = unknown;

export const useClearing = <
  TData = Awaited<ReturnType<typeof clearing>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof clearing>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getClearingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const sql = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/operations/own/exception/sql`,
    method: 'GET',
    signal,
  });
};

export const getSqlQueryKey = () => {
  return [`/operations/own/exception/sql`] as const;
};

export const getSqlQueryOptions = <
  TData = Awaited<ReturnType<typeof sql>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof sql>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSqlQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sql>>> = ({
    signal,
  }) => sql(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof sql>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SqlQueryResult = NonNullable<Awaited<ReturnType<typeof sql>>>;
export type SqlQueryError = unknown;

export const useSql = <
  TData = Awaited<ReturnType<typeof sql>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof sql>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSqlQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const invalidFormat = (partnerContactRequest: PartnerContactRequest) => {
  return customInstance<void>({
    url: `/operations/own/exception/validation`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: partnerContactRequest,
  });
};

export const getInvalidFormatMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invalidFormat>>,
    TError,
    { data: PartnerContactRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invalidFormat>>,
  TError,
  { data: PartnerContactRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invalidFormat>>,
    { data: PartnerContactRequest }
  > = (props) => {
    const { data } = props ?? {};

    return invalidFormat(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvalidFormatMutationResult = NonNullable<
  Awaited<ReturnType<typeof invalidFormat>>
>;
export type InvalidFormatMutationBody = PartnerContactRequest;
export type InvalidFormatMutationError = unknown;

export const useInvalidFormat = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invalidFormat>>,
    TError,
    { data: PartnerContactRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof invalidFormat>>,
  TError,
  { data: PartnerContactRequest },
  TContext
> => {
  const mutationOptions = getInvalidFormatMutationOptions(options);

  return useMutation(mutationOptions);
};
